import { encode } from "html-entities";
import htmr from "htmr";
import { useState } from "react";
import { StyleSheet, View } from "react-native";

import { useContentResource } from "@ctv/core";
import { Button, Card, formatMessage, Text, Token } from "@ctv/shared-core/src";

import ArrowRight from "@traveloka/icon-kit-web/react/IcSystemArrowRight16";
import Done from "@traveloka/icon-kit-web/react/IcSystemStatusOkDoneFill";
import { usePreRegisterConfirm } from "../../_contexts/PreRegisterConfirmContext";

import AddEmailModal from "./AddEmailModal";

export default function RegistrationSubmitted() {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const cr = useContentResource().CorporateRegistration;
  const data = usePreRegisterConfirm()!;

  const emails = [data.picEmail];

  if (data.otherEmails) {
    emails.push(...data.otherEmails);
  }

  return (
    <>
      <Card style={[styles.card, styles.marginBtmM]}>
        <View style={styles.icon}>
          <Done
            color={Token.color.greenPrimary}
            accentColor={Token.color.greenPrimary}
            width={24}
            height={24}
          />
          <Text style={styles.title} variant="title-2">
            {cr.successfulSubmitTitle}
          </Text>
        </View>
        <Text variant="ui-small">
          {htmr(
            formatMessage(cr.successfulSubmitInfo, {
              emails: emails
                .map((email) => `<b>${encode(email)}</b>`)
                .join(", "),
            })
          )}
        </Text>
      </Card>
      {!data.otherEmails?.length && (
        <>
          <Card style={styles.card}>
            <Text style={styles.otherEmailLabel}>{cr.otherEmailLabel}</Text>
            <Button
              style={styles.addEmailButton}
              endIcon={
                <ArrowRight
                  color={Token.color.bluePrimary}
                  accentColor={Token.color.bluePrimary}
                  width={16}
                  height={16}
                />
              }
              text={cr.addEmailText}
              variant="text-primary"
              onPress={() => setIsModalVisible(true)}
            />
          </Card>
          <AddEmailModal
            isVisible={isModalVisible}
            onClose={() => setIsModalVisible(false)}
          />
        </>
      )}
    </>
  );
}

const styles = StyleSheet.create({
  card: {
    padding: Token.spacing.l,
  },
  marginBtmM: {
    marginBottom: Token.spacing.m,
  },
  otherEmailLabel: {
    marginBottom: Token.spacing.xs,
  },
  icon: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: Token.spacing.m,
  },
  title: {
    marginLeft: Token.spacing.xs,
  },
  addEmailButton: {
    //@ts-expect-error -- fit-content value doesn't exist in typing
    width: "fit-content",
  },
});
